import React from "react";

const NotFound = props => (
    <div>
      Vi beklager, men vi kender ikke den side, du leder efter. Prøv i stedet at finde siden via menuen eller ved hjælp af oversigten herunder.
    </div>
);

export default NotFound;
